<script setup lang="ts">
import { inject, computed, type ComputedRef } from "vue";
import { useScreen } from "@/composable/useResponsive";
import DRMenuLinkItem from "./DRMenuLinkItem.vue";
import type { MenuEntity } from "./menu.types";
import { MenuType } from "./menu.types";

withDefaults(
  defineProps<{
    item: MenuEntity;
    type?: "primary" | "params" | "dark";
  }>(),
  {
    type: "primary",
  }
);

const { screen } = useScreen();
const menuMinimal = inject<ComputedRef<boolean | undefined>>("menuMinimal");

// Use injected minimal prop if provided, otherwise fallback to screen-based detection
const isMinimal = computed(() => {
  if (menuMinimal?.value !== undefined) {
    return menuMinimal.value;
  }
  return screen.value.lt.lg;
});
</script>

<template>
  <DRMenuLinkItem v-if="item.type === MenuType.LINK" :item="item" :type="type">
  </DRMenuLinkItem>
  <template v-else-if="item.type === MenuType.GROUP">
    <el-menu-item-group v-if="!isMinimal" class="mt-3 mb-1 px-4">
      <span
        class="text-uppercase fw-bold text-center"
        style="font-size: 0.7rem"
        :class="{
          'text-white': type === 'dark',
          'text-dark': type !== 'dark',
        }"
        >{{ $t(item.label) }}</span
      ></el-menu-item-group
    >
    <el-menu-item-group v-else class="divider"></el-menu-item-group>

    <DRMenuItem
      v-for="(childItem, id) in item.children"
      :key="id"
      :item="childItem"
      :type="type"
    />
  </template>
</template>

<style lang="scss" scoped>
.divider {
  padding: 0 !important;
  height: 2px;
  width: 100%;
  background-color: var(--bs-light);
  margin-bottom: 1rem;
  margin-top: 1rem;
}
</style>
